import React from "react"
import autobind from "class-autobind"
import { Chip } from "material-ui"
import { IDate, IQuestionDocument } from "../../../models"
import strings from "../../../localization/strings"
import * as api from "../../../api"
import { red500, green500, grey50 } from "material-ui/styles/colors"
import PunchQuestionAnswerDetailDialog from "./PunchQuestionAnswerDetailDialog"
interface IProps {
    imageS3Url: string
    punchDateTimeLocal: IDate
    btn1Ids: string[]
    btn2Ids: string[]
}
interface IState {
    questionDoc: IQuestionDocument
    exceptionBtnExist: boolean
    openPunchQuestionAnswerDetailDialog: boolean
}

export default class PunchQuestionAnswerChip extends React.Component<IProps, IState> {
    private isQuestionPunch
    constructor(props: IProps) {
        super(props)
        this.isQuestionPunch = (this.props.btn1Ids && this.props.btn1Ids.length > 0) || (this.props.btn2Ids && this.props.btn2Ids.length > 0)
        this.state = {
            questionDoc: null,
            exceptionBtnExist: false,
            openPunchQuestionAnswerDetailDialog: false
        }
        autobind(this)
    }

    componentDidMount() {
        this.isQuestionPunch &&
            this.getQuestionDoc()
    }

    getQuestionDoc() {
        const questionGUID = this.props.btn1Ids && this.props.btn1Ids.length ? this.props.btn1Ids[0] : this.props.btn2Ids[0]
        api.getQuestionByQuestionGUID(questionGUID).then(res => {
            const questionDoc = res.data as IQuestionDocument
            const btn1Ids = this.props.btn1Ids || []
            let exceptionBtnExist = btn1Ids.find(i => {
                const question = questionDoc.Questions.find(q => q.GUId === i)
                return [-2, -1].includes(question.Btn1Action) || (question.Btn1Action >= 0 && question.CreateBtn1Exception)
            }) !== undefined
            if (!exceptionBtnExist) {
                const btn2Ids = this.props.btn2Ids || []
                exceptionBtnExist = btn2Ids.find(i => {
                    const question = questionDoc.Questions.find(q => q.GUId === i)
                    return [-2, -1].includes(question.Btn2Action) || (question.Btn2Action >= 0 && question.CreateBtn2Exception)
                }) !== undefined
            }
            this.setState({ questionDoc, exceptionBtnExist })
        })
    }

    render() {
        return this.isQuestionPunch && this.state.questionDoc &&
            <div>
                <Chip
                    style={{ backgroundColor: this.state.exceptionBtnExist ? red500 : green500 }}
                    labelColor={grey50}
                    onClick={() => this.setState({ openPunchQuestionAnswerDetailDialog: true })}
                >
                    {strings.Punch_Questions}
                </Chip>
                {this.state.openPunchQuestionAnswerDetailDialog &&
                    <PunchQuestionAnswerDetailDialog
                        imageS3Url={this.props.imageS3Url}
                        punchDateTimeLocal={this.props.punchDateTimeLocal}
                        questions={this.state.questionDoc.Questions}
                        btn1Ids={this.props.btn1Ids}
                        btn2Ids={this.props.btn2Ids}
                        handleClose={() => this.setState({ openPunchQuestionAnswerDetailDialog: false })}
                    />
                }
            </div>
    }
}